import { resolveDisplayImageUrl } from '../lib/assets';

export default function PuzzleCard({ puzzle }) {
  const isPlayable = puzzle.status === 'playable';
  const thumbnailSrc = resolveDisplayImageUrl(puzzle.thumbnail);

  return (
    <div className="group mx-auto flex h-full w-full max-w-[17rem] flex-col overflow-hidden rounded-[1.4rem] border border-slate-200 bg-white shadow-sm transition duration-200 hover:-translate-y-1 hover:shadow-xl">
      <div className="relative aspect-[5/4] overflow-hidden bg-slate-50">
        {thumbnailSrc ? (
          <img
            src={thumbnailSrc}
            alt={puzzle.title}
            className="h-full w-full object-contain p-3 transition duration-300 group-hover:scale-[1.03]"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-sm font-medium uppercase tracking-[0.2em] text-slate-400">
            Prism
          </div>
        )}
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide ${
            isPlayable
              ? 'bg-emerald-100 text-emerald-700'
              : 'bg-amber-100 text-amber-700'
          }`}
        >
          {isPlayable ? 'Playable now' : 'Coming soon'}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="text-lg font-semibold text-slate-900">
          {puzzle.title}
        </h3>
        {puzzle.description ? (
          <p className="mt-2 max-h-[6.75rem] overflow-hidden text-sm leading-6 text-slate-600">
            {puzzle.description}
          </p>
        ) : null}
        <div className="mt-auto flex items-center justify-between pt-4">
          <span className="text-[11px] uppercase tracking-[0.2em] text-slate-400">
            {puzzle.puzzleCount
              ? `${puzzle.puzzleCount} public puzzle${puzzle.puzzleCount === 1 ? '' : 's'}`
              : 'New type'}
          </span>
          <span
            className={`rounded-full px-3.5 py-2 text-sm font-semibold ${
              isPlayable
                ? 'bg-brand-cyan text-white'
                : 'bg-slate-100 text-slate-500'
            }`}
          >
            {isPlayable ? 'Explore' : 'Preview'}
          </span>
        </div>
      </div>
    </div>
  );
}
